import styled, { keyframes } from 'styled-components';

const dotBounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
  40%           { transform: translateY(-4px); opacity: 1; }
`;

/**
 * Domyślnie loader WYPEŁNIA RODZICA, nie ekran. Wcześniej był zawsze `position: fixed`
 * na cały viewport z własnym tłem i z-index 50, więc loader Dashboardu albo fallback
 * Suspense w treści zakrywał już wyrenderowany sidebar i topbar: panel pojawiał się,
 * znikał pod krążkiem i pojawiał ponownie. Guardy tras renderują go w kontenerze
 * `h-[100vh]`, więc tam wygląda identycznie jak dawniej; pełnoekranowy wariant
 * (`$fullscreen`) zostaje dla miejsc bez żadnego layoutu pod spodem.
 */
/** Czas jednego obrotu spinnera HeroUI (`spinner-spin 0.8s`), do synchronizacji fazy. */
export const SPIN_DURATION_MS = 800;

export const Container = styled.div<{ $fullscreen?: boolean }>`
  /* Kolejne loadery (bramka startowa → fallback trasy → loader Dashboardu) to osobne
     montaże, więc animacja startowałaby od zera przy każdym i całość wyglądała jak
     przycięcie. Ujemne opóźnienie liczone ze wspólnego zegara (ustawiane inline przez
     komponent w --hs-spin-phase) stawia każdy nowy spinner w fazie poprzedniego. */
  & i {
    animation-delay: var(--hs-spin-phase, 0ms) !important;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  ${({ $fullscreen, theme }) => ($fullscreen
    ? `
      position: fixed;
      inset: 0;
      z-index: 50;
      background: ${theme.mode === 'dark' ? '#111827' : '#f9fafb'};
    `
    : `
      /* Stała wysokość zamiast flex: 1, żeby każdy loader w treści (fallback trasy,
         loader Dashboardu, Suspense bloków Dashboardu) stawiał krążek w tym samym
         punkcie ekranu niezależnie od tego, co jest rodzicem. */
      min-height: 50vh;
    `)}
`;

export const LoadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LoadingDots = styled.div`
  display: flex;
  gap: 4px;
`;

export const LoadingDot = styled.div<{ $delay: number }>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1a4d4d;
  animation: ${dotBounce} 1.2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;

export const LoadingText = styled.span`
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#9ca3af')};
  letter-spacing: 0.3px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

export const Title = styled.h3`
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1f2937')};
  line-height: 1.5;
  margin: 0;
`;

export const Description = styled.p`
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  line-height: 1.6;
  margin: 0;
`;
